/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowLargeLeftIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAq0lEQVR4nGNgGAXUAh6hoaK+ARH7/QIi5tDEcD//iMt+ARH/QZZQ3XDfgPBLIMP9/MOve4WGSowazjAaLDiBr3/4SXBqoQT7hx/GbUFA+AlKLfANiDiE0wJv7yhB34DwM1CFNwIDoyUZqA2QLQFlLLpY4kXN3Du8LfH1j7hGE0t8fCJF/ALCL0J8EnE2NDSUmTaW+Eec9QuIeOLh4cHOQAtgb2/PQjPDBy0AAMpVuelrnYzgAAAAAElFTkSuQmCC)
 */
export const ArrowLargeLeftIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3.3 11.3a1 1 0 0 0 0 1.4l8 8a1 1 0 1 0 1.4-1.4L6.42 13H20a1 1 0 1 0 0-2H6.41l6.3-6.3a1 1 0 0 0-1.42-1.4l-8 8Z"
        className={colorClass}
      />
    </svg>
  );
};
